import { make } from 'vuex-pathify';

const state = {
	articlesLoading: {
        changing: false,
        type: 'move',
    },
};

const getters = {};

const mutations = {
	...make.mutations(state),
};

const actions = {
	...make.actions(state),
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
